/* ER · Client-side pagination for the Judge.me All Reviews widget.
   The metafield embed renders every review into the DOM at once, which
   makes the page enormous. This chunks them into pages with prev/next
   arrows, and re-syncs when the user switches tabs or changes sort. */
(function () {
  'use strict';

  var PER_PAGE = 15;
  var busy = false;

  function root() {
    return document.querySelector('.er-all-reviews');
  }

  function reviewList() {
    var r = root();
    if (!r) return null;
    return r.querySelector('.jdgm-rev-widg__reviews') || r.querySelector('.jdgm-all-reviews__body');
  }

  /* Reviews Judge.me itself has filtered out carry an inline display:none.
     We hide with a class instead, so the two never get confused. */
  function candidates(list) {
    return Array.prototype.filter.call(
      list.querySelectorAll('.jdgm-rev'),
      function (el) { return el.style.display !== 'none'; }
    );
  }

  function showPage(items, page) {
    var start = (page - 1) * PER_PAGE;
    var end = start + PER_PAGE;
    items.forEach(function (el, i) {
      if (i >= start && i < end) el.classList.remove('er-rev-hidden');
      else el.classList.add('er-rev-hidden');
    });
  }

  function pageNumbers(total, current) {
    if (total <= 7) {
      var all = [];
      for (var i = 1; i <= total; i++) all.push(i);
      return all;
    }
    var out = [1];
    var from = Math.max(2, current - 1);
    var to = Math.min(total - 1, current + 1);
    if (from > 2) out.push('...');
    for (var j = from; j <= to; j++) out.push(j);
    if (to < total - 1) out.push('...');
    out.push(total);
    return out;
  }

  function removeNav() {
    var r = root();
    if (!r) return;
    r.querySelectorAll('.er-rev-pager, .er-rev-pager__count').forEach(function (n) {
      n.parentNode.removeChild(n);
    });
  }

  function renderNav(list, items, total, current) {
    removeNav();

    var count = document.createElement('div');
    count.className = 'er-rev-pager__count';
    var first = (current - 1) * PER_PAGE + 1;
    var last = Math.min(current * PER_PAGE, items.length);
    count.textContent = 'Showing ' + first + '\u2013' + last + ' of ' + items.length + ' reviews';

    var nav = document.createElement('nav');
    nav.className = 'er-rev-pager';
    nav.setAttribute('aria-label', 'Reviews pagination');

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'er-rev-pager__arrow';
    prev.setAttribute('aria-label', 'Previous page');
    prev.innerHTML = '&#8249;';
    prev.disabled = current === 1;
    prev.addEventListener('click', function () { go(current - 1); });
    nav.appendChild(prev);

    var pages = document.createElement('span');
    pages.className = 'er-rev-pager__pages';
    pageNumbers(total, current).forEach(function (n) {
      if (n === '...') {
        var gap = document.createElement('span');
        gap.className = 'er-rev-pager__gap';
        gap.textContent = '\u2026';
        pages.appendChild(gap);
        return;
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'er-rev-pager__page' + (n === current ? ' is-active' : '');
      b.textContent = n;
      b.addEventListener('click', function () { go(n); });
      pages.appendChild(b);
    });
    nav.appendChild(pages);

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'er-rev-pager__arrow';
    next.setAttribute('aria-label', 'Next page');
    next.innerHTML = '&#8250;';
    next.disabled = current === total;
    next.addEventListener('click', function () { go(current + 1); });
    nav.appendChild(next);

    list.parentNode.insertBefore(count, list);
    list.parentNode.insertBefore(nav, list.nextSibling);
  }

  function go(page) {
    var list = reviewList();
    if (!list) return;
    var items = candidates(list);
    var total = Math.ceil(items.length / PER_PAGE);
    if (page < 1 || page > total) return;

    busy = true;
    list.setAttribute('data-er-page', page);
    showPage(items, page);
    renderNav(list, items, total, page);
    busy = false;

    var r = root();
    if (r) {
      var top = r.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  function sync(force) {
    if (busy) return;
    var list = reviewList();
    if (!list) return;

    var items = candidates(list);
    var sig = items.length + '|' + (items[0] ? items[0].getAttribute('data-review-id') || '' : '');
    if (!force && sig === list.getAttribute('data-er-sig')) return;

    busy = true;
    list.setAttribute('data-er-sig', sig);

    var total = Math.ceil(items.length / PER_PAGE);
    if (total <= 1) {
      items.forEach(function (el) { el.classList.remove('er-rev-hidden'); });
      removeNav();
      busy = false;
      return;
    }

    var current = parseInt(list.getAttribute('data-er-page'), 10) || 1;
    if (current > total) current = 1;
    list.setAttribute('data-er-page', current);

    showPage(items, current);
    renderNav(list, items, total, current);
    busy = false;
  }

  function boot() {
    sync(true);

    var pending = null;
    function queue() {
      clearTimeout(pending);
      pending = setTimeout(function () { sync(false); }, 120);
    }

    if (window.MutationObserver) {
      var r = root();
      if (r) {
        new MutationObserver(function () { if (!busy) queue(); })
          .observe(r, { childList: true, subtree: true });
      }
    }

    /* Tab switches (Product Reviews / Shop Reviews) and sort changes
       re-render the list without a childList change we can rely on. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.er-all-reviews')) {
        setTimeout(function () { sync(true); }, 250);
      }
    }, true);

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.er-all-reviews')) {
        setTimeout(function () { sync(true); }, 250);
      }
    }, true);

    /* Judge.me can hydrate late */
    [400, 900, 1800].forEach(function (ms) {
      setTimeout(function () { sync(false); }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();